var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"px-xl-2 mx-auto",attrs:{"sm":"12","md":"12","lg":"12"}},[_c('img',{attrs:{"src":require("../../assets/images/logo/linksms-big.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }